var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRaceLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 836,
    height: 836,
    viewBox: "0 0 836 836",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 418,
    r: 418,
    fill: "#D52626"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 418,
    r: 346,
    stroke: "white",
    strokeWidth: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M506.789 492.16C530.636 480.742 549.602 464.004 563.688 441.947C577.773 419.89 584.81 394.093 584.799 364.556C584.799 343.287 581.086 323.792 573.66 306.071C566.233 288.351 555.773 273.187 542.278 260.579C528.786 247.979 512.853 238.232 494.477 231.339C476.101 224.446 455.962 221 434.059 221H303.009L238 319.654H434.076C448.154 319.654 459.69 324.086 468.684 332.948C477.678 341.81 482.176 353.725 482.176 368.692C482.176 383.659 477.678 395.572 468.684 404.43C459.69 413.289 448.154 417.72 434.076 417.724H303.009L238 507.522H393.021L469.271 605H603L506.806 492.16H506.789Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaceLogo);
export default __webpack_public_path__ + "static/media/race-logo.2c6a8eae9d0a902137983918372ec3ad.svg";
export { ForwardRef as ReactComponent };